import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../../../Header/Header'
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading'
import * as jnb from 'react-bootstrap';
import { FaHandPointRight } from 'react-icons/fa';
import { useQuery } from '@tanstack/react-query';
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { useSelector } from 'react-redux';

export default function CessPaymentReport() {
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const username = loginreducer.username
    // console.log("logindata",loginreducer.username)
    const [showData, setData] = useState([])
    const navigate = useNavigate()
    // function getDataFunction() {
    //     let url = config.url.BOC_URL + "cess-payment-report";
    //     CommonAxiosGet(url).then((response) => {
    //         if (response.data.status === true) {
    //             setData(response.data.cess_payment_report);
    //         }
    //         else {
    //             setData([])
    //         }
    //     })
    // };

    const { data: response } = useQuery({
        queryKey: ['cessPayment0', username],
        queryFn: () => CommonAxiosGet(config.url.BOC_URL + 'cess-payment-view?userId=' + username),
        // staleTime: 5 * 60 * 1000,
        staleTime: 60 * 60 * 1000,   // 1 hour in milliseconds
        cacheTime: 60 * 60 * 1000    // 1 hour in milliseconds
        // enabled: !!org_id, // Only fetch if org_id is truthy
    });
    useEffect(() => {
        // getDataFunction()
        if (response?.data?.scode === "01") {
            setData(response?.data?.cessView)
        } else {
            setData([])
        }
    }, [response])
    function navcesspaymntform() {
        navigate("/cessPaymentForm");
    }
    return (
        <div>
            <React.Fragment>
                <Header />
                <div className="main_section"> </div>
                <CommonPageHeading heading="CESS Payment Report" />
                <jnb.Container className="outer-page-content-container" >

                    <div className="px-2 mt-2 text-right" onClick={() => navcesspaymntform()}>
                        <FaHandPointRight></FaHandPointRight>&nbsp;
                        <span className="text-decoration-underline">Click here to apply</span> &nbsp;
                        <i className="badge badge-success forgot mb-4 fw-bold " data-toggle="tooltip" animation="true" title="Click Me!"
                        > New Cess Payment</i>
                    </div>

                    <div className="form-card-jnb" >
                        <jnb.Row className="pt-1">
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                    style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                >
                                    {showData?.length > 0 ?
                                        <thead style={{ border: "1px solid black" }}>
                                            <tr>
                                                <th rowSpan={2}>S.NO</th>
                                                <th rowSpan={2}>Cess Referral ID</th>
                                                <th rowSpan={2}>Value of Work</th>
                                                <th colSpan={3}>Cess Amount</th>
                                                {/* <th>Balance Pay Amount</th> */}
                                                <th rowSpan={2}>Payment Status</th>
                                                {/* <th colSpan={3}>Estimated Cost</th>
                                                <th colSpan={3}>CESS Amount</th>
                                                <th rowSpan={2}>Status</th> */}
                                            </tr>
                                            <tr>
                                                <th>Total<br/>(value of work 1%)</th>
                                                <th>Paid</th>
                                                <th>To be Paid</th>
                                            </tr>
                                        </thead>
                                        :
                                        <div className="text-center">
                                            <span className="centered-red-text">***********No Data Found************</span>
                                        </div>
                                    }

                                    <tbody>

                                        {showData?.map((data, index) => {
                                            return (
                                                <tr key={index} id={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{data?.id}</td>
                                                    <td className="text-right">{data?.value_of_work}</td>
                                                    <td className="text-right">{data?.cess_amount}</td>
                                                    <td className="text-right">{data?.paid_amount}</td>
                                                    <td className="text-right">{data?.remaining_amount}</td>
                                                    {
                                                        data?.payment_type === "F" ? <td className="text-success fw-bold" style={{ textDecoration: "underline",textAlign: "center" }} onClick={() => { navigate("/cessPaymentForm", { state: { status: "S", data: data,Id: data?.id } }) }}>Paid</td> :
                                                            <td onClick={() => { navigate("/cessPaymentForm", { state: { status: "P", data: data, Id: data?.id } }) }} style={{ textDecoration: "underline" }} className="text-danger fw-bold">Pending</td>
                                                    }
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </jnb.Row>
                    </div>
                </jnb.Container>
            </React.Fragment>
        </div>
    )
}
